(function () {
  let lockedScrollY = 0;
  const COMPANY_ID_FALLBACK = 'U6W3us';
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getModal() {
    return document.getElementById('NotifyModal');
  }

  function getCompanyId(modal) {
    if (modal && modal.dataset.klaviyoCompanyId) return modal.dataset.klaviyoCompanyId;

    const scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (let i = 0; i < scripts.length; i += 1) {
      const match = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/);
      if (match) return match[1];
    }

    return COMPANY_ID_FALLBACK;
  }

  function subscribeBackInStock(companyId, email, variantId, marketing) {
    const body = new URLSearchParams();
    body.set('a', companyId);
    body.set('email', email);
    body.set('variant', String(variantId));
    body.set('platform', 'shopify');
    if (marketing) body.set('subscribe_for_newsletter', 'true');

    return fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    }).then(function (response) {
      return response.json().catch(function () {
        return { success: response.ok };
      });
    });
  }

  function setStatus(statusEl, message, isError) {
    if (!statusEl) return;
    statusEl.hidden = !message;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', Boolean(isError));
  }

  function setCopy(modal, kicker, title, text) {
    const kickerEl = modal.querySelector('[data-notify-kicker]');
    const titleEl = modal.querySelector('[data-notify-title]');
    const textEl = modal.querySelector('[data-notify-text]');
    if (kickerEl) kickerEl.textContent = kicker;
    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;
  }

  function resetView(modal) {
    const form = modal.querySelector('[data-notify-form]');
    const done = modal.querySelector('[data-notify-done]');
    const status = modal.querySelector('[data-notify-status]');
    const submit = modal.querySelector('[data-notify-submit]');
    const productTitle = modal.dataset.productTitle;

    if (form) {
      form.hidden = false;
      form.reset();
    }
    if (done) done.hidden = true;
    if (submit) {
      submit.disabled = false;
      submit.textContent = 'Notify Me';
    }

    setCopy(
      modal,
      'Back in stock',
      'Get notified',
      productTitle
        ? 'Email me when ' + productTitle + ' is restocked.'
        : 'Email me when this item is restocked.'
    );
    setStatus(status, '', false);
  }

  function showSuccess(modal) {
    const form = modal.querySelector('[data-notify-form]');
    const done = modal.querySelector('[data-notify-done]');
    if (form) form.hidden = true;
    if (done) done.hidden = false;
    setCopy(
      modal,
      "You're on the list",
      "We'll email you",
      "As soon as this item is back, you'll be the first to know."
    );
    if (done) done.focus();
  }

  function lockPageScroll() {
    const html = document.documentElement;
    if (html.classList.contains('notify-modal-open')) return;

    if (
      html.classList.contains('header-search-open') ||
      html.classList.contains('header-menu-scroll-lock')
    ) {
      html.classList.add('notify-modal-open');
      return;
    }

    lockedScrollY = window.scrollY;
    document.body.style.setProperty('--scroll-lock-top', '-' + lockedScrollY + 'px');
    html.classList.add('notify-modal-open');
  }

  function unlockPageScroll() {
    const html = document.documentElement;
    if (!html.classList.contains('notify-modal-open')) return;

    html.classList.remove('notify-modal-open');
    if (
      html.classList.contains('header-search-open') ||
      html.classList.contains('header-menu-scroll-lock')
    ) {
      return;
    }

    document.body.style.removeProperty('--scroll-lock-top');
    window.scrollTo(0, lockedScrollY || 0);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    unlockPageScroll();
    resetView(modal);
  }

  function bind(modal) {
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.querySelectorAll('[data-notify-close], [data-notify-done]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal(modal);
    });

    const form = modal.querySelector('[data-notify-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const email = form.email && form.email.value ? form.email.value.trim() : '';
      const marketing = Boolean(form.marketing && form.marketing.checked);
      const variantId = modal.dataset.notifyVariantId;
      const status = modal.querySelector('[data-notify-status]');
      const submit = modal.querySelector('[data-notify-submit]');

      if (!email || !EMAIL_PATTERN.test(email)) {
        setStatus(status, 'Enter a valid email.', true);
        if (form.email) form.email.focus();
        return;
      }

      if (!variantId) {
        setStatus(status, 'Unable to subscribe. Reload and try again.', true);
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Sending...';
      }
      setStatus(status, '', false);

      subscribeBackInStock(getCompanyId(modal), email, variantId, marketing)
        .then(function (payload) {
          if (payload && payload.success === false) {
            throw new Error((payload.errors && payload.errors[0]) || 'Unable to subscribe.');
          }

          if (marketing && window.klaviyo && typeof window.klaviyo.identify === 'function') {
            window.klaviyo.identify({ email: email });
          }

          showSuccess(modal);
        })
        .catch(function () {
          setStatus(status, 'Unable to subscribe. Try again.', true);
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = 'Notify Me';
          }
        });
    });
  }

  window.RSNotifyModal = {
    open: function (options) {
      const modal = getModal();
      if (!modal) return;

      bind(modal);

      modal.dataset.notifyVariantId = options && options.variantId ? String(options.variantId) : '';
      modal.dataset.productTitle = options && options.productTitle ? options.productTitle : '';
      resetView(modal);
      modal.hidden = false;
      lockPageScroll();

      const emailInput = modal.querySelector('#NotifyModalEmail');
      if (emailInput) emailInput.focus();
    },
  };

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('[data-notify-open], .product-music__notify-button');
      if (!button || button.closest('.notify-modal')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantInput = document.querySelector('.product-variant-id');
      window.RSNotifyModal.open({
        variantId: button.dataset.notifyVariantId || (variantInput && variantInput.value),
        productTitle: button.dataset.productTitle,
      });
    },
    true
  );
})();
